module.exports = __webpack_public_path__ + "media/styles/images/svg/arrow-up-gray-medium-0564bef03f682364bd74073d2a641c59.svg";